import { ContextClassBase } from '../service/RuntimeContext.js';

var ConfigKeys;
(function (ConfigKeys) {
    ConfigKeys["SdkVersion"] = "sdk.version";
    ConfigKeys["DbVersion"] = "sdk.db.version";
    ConfigKeys["DbLastOpen"] = "sdk.db.last_open";
    ConfigKeys["DbEncyption"] = "sdk.db.encryption";
    ConfigKeys["UserToken"] = "user.token";
})(ConfigKeys || (ConfigKeys = {}));
class DbProxy extends ContextClassBase {
}

export { ConfigKeys, DbProxy };
//# sourceMappingURL=DbProxy.js.map
